import apiFetch from '../apiFetch'

export default function (token, organizedUnitSaleOperation) {
  return apiFetch({ endPoint: `OrganizedUnitSaleOperation/${organizedUnitSaleOperation.organizedUnitSaleOperationId}`, method: 'PUT', body: organizedUnitSaleOperation, token: token })
}
